<template>
  <div>
    <div class="w">
    <div class="title">Tetra® 德彩品牌简介</div>
    <div class="desc_container">
      <p class="article">
        <span>
          Tetra®德彩是全球排名第一的德国高端水族品牌，总部位于德国北部的下萨克森州的Melle小镇。到2021年，德彩已经有70年的历史，
          是世界上第一个发明热带鱼薄片食品并将其进行工业化生产的品牌。于2005年被美国上市公司品谱集团
          (Spectrum Brands)收购。
        </span>
      </p>
    </div>

    <div class="title">品牌故事</div>
    <div class="desc_container">
      <p class="article">
        <span>
          在20世纪50年代，德国只有大约50,000名养鱼者，饲养观赏鱼都是一件十分耗时且复杂的事情。因为水族爱好者们需要从溪流与河水中捕捉活食来为观赏鱼提供天然的营养。
          这种最原始的饲养方法既费时费力，又不能保证观赏鱼摄取到足够的营养同时也无法使水族产品生产走向产业化。
        </span>
        <br /><br />
        <span>
          1955年，德国自然科学家Ulrich
          Baensch博士发明了全球第一种观赏鱼薄片饲料TetraMin,
          TetraMin是希腊文，意思是四种含有维他命的薄片，TetraMin
          由四种不同类型的含维生素的薄片组成。Tetra是希腊文4的意思，Min则是VITAMIN*维生素的第三个音节。Tetra®德彩公司德文名称Tetra也来源于此。德彩公司将这种观赏鱼薄片饲料进行工业化生产，由此带来了饲养观赏鱼的革命，
          一个全新的水族行业由此诞生并蓬勃发展。如今由40种精选原料组成的TetraMin已经成为全球最多的观赏鱼爱好者使用的鱼粮。
        </span>
        <br /><br />
        <!-- 分段01 -->
        <span style="font-weight: 600; color: #333">德国制造，全球成功</span
        ><br /><br />
        <span>
          德彩成功的秘诀在于深入研究、专利产品和质量保证之间的成功互动，这也是根据国际标准ISO
          9001:2008和HACCP的认证。这就是德彩作为一个品牌，70多年来成功地在消费者和德彩的零售伙伴中建立了客户对德彩产品的信心。如今，
          Tetra®德彩产品通过全球区域联盟网络销往全球 120
          多个国家/地区，在德国、法国、英国、意大利、波兰、美国、日本、新加坡和中国设有办事处。
        </span>
        <br /><br />
        <span>
          德彩保持着水产行业中最大的独立认证的研究和开发部门。德彩公司活动的重点是通过不断的研究和开发，使养鱼的爱好更容易、更安全、更人性化。德彩有一个在行业内独一无二的研发部门：高素质的员工，包括生物学家、化学家、兽医和工艺工程师，他们负责进一步开发新的、产品改进和质量管理。该部门与全球营销部门密切合作，通过全球市场调查研究，
          以了解和提供消费者的要求。由于这种深入的合作，德彩公司开发的产品既能满足鱼类的需求，也能满足水族馆主人的需求。
        </span>
        <br /><br />
        <span>
          此外，德彩的产品种类繁多，有的获得了专利，有的采用了专利技术，有的包含了专利部件，这些都是德彩的基石。
        </span>
        <br /><br />
        <!-- 分段02 -->
        <span style="font-weight: 600; color: #333"
          >Tetra®德彩是美国品谱品牌公司的一部分</span
        ><br /><br />
        <span>
          2005年，Tetra®德彩被美国品谱品牌公司收购。这家全球消费品制造商是以下产品组的全球领先供应商之一：
        </span>
        <br /><br />
        <span> •电池和电器 </span>
        <br /><br />
        <span> •家庭和花园 </span>
        <br /><br />
        <span> •宠物 </span>
        <br /><br />
        <span>
          该公司包括许多市场领先的，知名和值得信赖的品牌。除Tetra®德彩外，还包括Russell
          Hobbs ® Remington ®, Rayovac ®, George Foreman ®, Toastmaster ®,
          Farberware ®, LITTERMAID ®, 8in1 ®, FURminator ®, Marineland ®,
          Nature's Miracle ®, Dingo ®, Kwikset ®, Cutter ®, Repel ®, and Liquid
          Fence ®.
        </span>
        <br /><br />
        <span>
          集团的产品在全球前 25 家零售商和约 140 个国家/地区的 100
          多万家商店销售。 品谱品牌在美国股指罗素2000上市。在 2013
          财年，品谱品牌控股实现了约 41 亿美元的净销售额。
        </span>
        <br /><br />
        <span>
          2008年Tetra®德彩在欧洲推出8in1宠物品牌。该品牌的核心重点在于宠物零食和护理。
          品谱品牌的宠物部门在2012年扩展，引进了FURMinator品牌，为狗、猫和其他动物提供了广泛的优质专利美容和卫生产品。
        </span>
      </p>
    </div>

    <div class="title">发展历程</div>
    <div class="desc_container">
      <p class="article">
        <span>
          1951年，德国自然科学家Ulrich
          Baensch博士在汉诺威注册了Tropenhaus（后来的Tetra）公司。
          两年后，他成立了BioMin实验室， 在那里他能够测试和进一步开发他的产品。
          在此期间，他向市场推出了许多创新产品并申请了多项专利。
        </span>
        <br /><br />
        <span>
          1962年，拥有约20名员工的公司总部迁至Melle，并更名为Tetra Kraft
          Werke。当时，
          Baensch博士已经注册了15项制造工艺的专利和20个商标。公司还出版了第一本水族杂志《Die
          Wasserfloh-Post》。
        </span>
        <br /><br />
        <span>
          1970年代初，生产规模扩大到Offelten的新厂区。当时，德彩当时拥有约420名员工。同时，德彩公司首次对亚马逊进行了考察。
          1974年，公司被出售给美国Warner-Lambert集团，从而迈出了全球化的第一步。
        </span>
        <br /><br />
        <span>
          1980年代，此时，花园池塘越来越受欢迎，德彩推出了Tetra
          Pond，这是其在花园池塘领域的第一个完整产品系列，包括食物、护理和技术。
          创新的Pond
          Sticks的棍状食物可以漂浮在花园池塘的表面，这样你就可以不受干扰地观察鱼的进食。
        </span>
        <br /><br />
        <span>
          2000年辉瑞公司Pfizer收购了Warner-Lambert集团及其旗下所有的公司。
        </span>
        <br /><br />
        <span>
          2002年12月，辉瑞公司Pfizer将Tetra®德彩出售给欧洲独立私募股权基金特里顿Triton。
          不到三年后，德彩公司被美国全球消费品集团品谱Spectrum Brands接管。
        </span>
        <br /><br />
        <span>
          2005年，美国消费品集团Spectrum Brands接管了该公司。
          梅勒（Melle）的生产基地进行了扩展，以适应灌装和包装生产，
          该生产将从Offelten迁移到梅勒（Melle）。 8in1品牌也整合到了Melle工厂。
        </span>
        <br /><br />
        <span>
          近年来，根据IFS
          Food标准实施了质量保证，并且德彩品牌的设计在全球范围内重新推出。
          德彩现在在产品，技术和制造工艺方面拥有独特的多项专利。
        </span>
      </p>
    </div>

    <div class="title">Tetra®德彩产品</div>
    <div class="desc_container">
      <p class="article">
        <span>
          目前，Tetra®德彩的产品线在水族产业已覆盖非常广的范围，德彩生产各种水族馆和花园池塘产品,包括
          <strong>
            热带鱼、冷水鱼、海水鱼、锦鲤以及爬行类动物饲料，
            水质稳定剂，水质测试剂，水族类设备如鱼缸、过滤桶，以及水草护理、水族医药用品 </strong
          >等。
        </span>
        <br /><br />
        <span> Tetra®德彩在中国取得农业部批准允许进口出售的产品: </span>
        <br /><br />
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="No." width="180">
          </el-table-column>
          <el-table-column prop="name" label="中文名称" width="180">
          </el-table-column>
          <el-table-column prop="address" label="名称"> </el-table-column>
          <el-table-column prop="product" label="Name of the Product">
          </el-table-column>
        </el-table>
        <br>
        <span>这些产品全部都是在德国的MELLE进行研发和生产的。</span>
      </p>
    </div>

    <div class="title">Tetra®德彩公司的可持续发展</div>
    <div class="desc_container">
      <p class="article">
        <span>
            作为一家全球性公司，Tetra®德彩了解日益全球化对环境的影响。因此，在日常资源工作中，
            Tetra®德彩努力采取负责任的行动，确保公司的可持续性，Tetra®德彩公司内部实行积极的,可持续的企业政策。
        </span>
        <br /><br />
        <span>
            德彩公司有着在全球水族行业最大的研发团和开发部门，公司工作的重点之一是创新产品的开发，
            为保护我们的自然、环境和自然资源做出巨大贡献。在这里，德彩公司年复一年地设定新的标准。
        </span>   
      </p>
    </div>
    <div class="title">包装和采购</div>
    <div class="desc_container">
      <p class="article">
        <span>
            谨慎使用我们的资源对Tetra®德彩非常重要。
            无论是包装还是采购，Tetra®德彩都注重短途运输路线、环保材料、无纸化办公室和最佳的回收选择。
        </span>
      </p>
    </div>
    <div class="title">生产和环境</div>
    <div class="desc_container">
      <p class="article">
        <span>
            最大限度地节约我们的环境是推动Tetra®德彩整个生产过程的一项原则。
            因此，Tetra®德彩不断努力在环境兼容性方面优化所有的业务领域。
        </span>
      </p>
    </div>
    <div class="title">物流</div>
    <div class="desc_container">
      <p class="article">
        <span>
            从德国的总部，德彩公司把产品运送到全球大约120个国家。由最佳的规划和可靠的合作伙伴，
            德彩公司以无害环境的方式管理运输--这样可以尽可能地减少对环境的影响，使碳足迹降到最低。
        </span>
      </p>
    </div>
    <div class="title">对话</div>
    <div class="desc_container">
      <p class="article">
        <span>
            在Tetra®德彩，可持续行动不仅指传统的环境保护，还指与Tetra®德彩的员工、股东、客户、消费者、组织、
            学者、政府机构和公众合作。在这样做的同时，Tetra®德彩将专注于知识共享。
        </span>
      </p>
    </div>
    <div class="title">员工</div>
    <div class="desc_container">
      <p class="article">
        <span>
            Tetra®德彩的员工及其在各自领域的专业知识是Tetra®德彩公司成功的关键。
            真正的团队合作、多样化的培训以及积极和个性化的员工发展对Tetra®德彩来说是基石。
        </span>
      </p>
    </div>
    <div class="title">社会责任</div>
    <div class="desc_container">
      <p class="article">
        <span>
            Tetra®德彩在许多方面承担着社会责任。比如帮
            助在学校和幼儿园设立水族馆，长期支持海洋生物水族馆，向慈善机构捐款，同时还为员工举办健康日活动。
        </span>
      </p>
    </div>

  </div>
<!-- 底部 -->
<div style="height: 100px;"></div>
  <foot/>
  </div>
</template>
<script>
export default {
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
  },
  data() {
    return {
      tableData: [
        {
          date: "1",
          name: "德彩金鱼成长饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Marine XL Granules"
        },
        {
          date: "2",
          name: "德彩海水鱼颗粒饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Goldfish Gold Growth"
        },
        {
          date: "3",
          name: "德彩热带鱼七彩颗粒饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Bits Complete"
        },
        {
          date: "4",
          name: "德彩血鹦鹉饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Red Parrot"
        },
        {
          date: "5",
          name: "德彩热带鱼颗粒饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Min Mini Granules"
        },
        {
          date: "6",
          name: "德彩龟饲料",
          address: "Compund Feed for Turtle",
          product: "Tetra ReptoMin"
        },
        {
          date: "7",
          name: "德彩池塘锦鲤饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Pond Sticks"
        },
        {
          date: "8",
          name: "德彩慈鲷鱼饲料",
          address: "Compund Feed for Ornamentral Fish",
          product: "Tetra Cichlid Granules"
        },
     
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.title {
  margin: 20px auto;
  font-size: 20px;
  color: #333;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
}

.desc_container {
  margin-top: 20px;
  padding: 15px 15px;
  background-color: #f8f8f8;
  .article {
    margin: 0;
    padding: 0;
    span {
      font-size: 16px;
      color: #666;
      line-height: 1.75em;
    }
  }
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
::v-deep .el-table thead {
  color: #333;
}
</style>